var React = require('react');

function Rectangle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"currentColor"},React.createElement("path",{"d":"M195 200L295 200 295 351 245 325 195 351z","transform":"translate(-195 -200)"}))));
}

Rectangle.defaultProps = {"width":"100","height":"151","viewBox":"0 0 100 151"};

module.exports = Rectangle;

Rectangle.default = Rectangle;
